document.addEventListener("DOMContentLoaded", function () {
  const targets = document.querySelectorAll('.js-map');

  const options = {
    root: null,
    rootMargin: '0px',
    threshold: 0.6
  };

  const callback = (entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const block = entry.target;
        block.classList.add('is_active');

        // 子要素の achievementsMap__spots にも is_active を追加
        const spot = block.querySelector('.js-map__spots');
        if (spot) {
          spot.classList.add('is_active');
        }

        observer.unobserve(block); // 監視を解除
      }
    });
  };

  const observer = new IntersectionObserver(callback, options);

  targets.forEach(target => {
    observer.observe(target);
  });
});
